import React, { useState } from "react";
import { Modal, Tag, Typography } from "antd";
import SignaturePad from "./signaturePad";

/**
 * The signature pad behind a link, instead of sitting in the form.
 *
 * The link reads "Sign here", or "Signed" once there is one, and the pad opens wide and
 * short — the shape a signature is actually written in. Inline the pad is only as wide as
 * its column, so in a table row people end up signing vertically.
 *
 * Every other prop is handed straight to the pad, so it can stand in for it anywhere.
 */
export default function SignatureModalPad({
    onSave,
    initialImage,
    disabled = false,
    hasSignature,
    height = 200,
    ...padProps
}) {
    const [open, setOpen] = useState(false);
    const signed = hasSignature ?? !!initialImage;

    return (
        <>
            <Typography.Link disabled={disabled} onClick={() => setOpen(true)}>
                {signed ? "Signed" : "Sign Here"}
            </Typography.Link>

            <Modal
                title={
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        Signature
                        {signed ? <Tag color="success">Signed</Tag> : <Tag>Not signed</Tag>}
                    </span>
                }
                open={open}
                onCancel={() => setOpen(false)}
                footer={null}
                width="95%"
                style={{ maxWidth: 760, top: 24 }}
                destroyOnHidden
                maskClosable={false}
            >
                <SignaturePad
                    {...padProps}
                    initialImage={initialImage}
                    disabled={disabled}
                    height={height}
                    maxWidth="none"
                    onSave={(image) => {
                        onSave?.(image);
                        setOpen(false);
                    }}
                />
            </Modal>
        </>
    );
}
